import React from "react";
import "./TermCondition.css";

const TermCondition = () => {
  return (
    <section className="yterms-policy">
      <div className="yterms-container">
        <h1 className="yterms-title">
          Terms & Conditions – Budget Golden Triangle Tours
        </h1>

        <p className="yterms-intro">
          Welcome to Budget Golden Triangle Tours. These Terms & Conditions
          govern the use of our website, travel services, and tour packages.
          By booking or accessing our website, you agree to comply with the
          following terms and conditions.
        </p>

        <div className="yterms-content">

          <p>
            <strong>Office Address:</strong><br/>
            New Delhi, India
          </p>

          <div className="yterms-full-text">

            <h3>1. Booking & Acceptance</h3>
            <p>
              All bookings made with Budget Golden Triangle Tours are subject
              to availability and confirmation after receipt of advance or
              full payment. Customers must provide accurate personal and
              travel information at the time of booking.
            </p>

            <h3>2. Travel Documents</h3>
            <p>
              Travelers are responsible for carrying valid passports,
              visas, government identification, and any permits required
              for travel within India. We are not liable for issues arising
              from incomplete or invalid travel documentation.
            </p>

            <h3>3. Health & Safety</h3>
            <p>
              Travelers must ensure they are medically fit for travel.
              Any medical conditions should be disclosed before booking.
              Guests are responsible for personal safety and belongings
              during the tour.
            </p>

            <h3>4. Payments Policy</h3>
            <ul>
              <li>Advance payment is required to confirm bookings.</li>
              <li>Remaining balance must be paid before tour commencement.</li>
              <li>Prices may change due to taxes, fuel costs, or government regulations.</li>
            </ul>

            <h3>5. Cancellation & Refund Policy</h3>
            <p>Cancellation charges apply as follows:</p>
            <ul>
              <li>30 days before travel – Minimal cancellation charges.</li>
              <li>15–30 days before travel – Partial refund applicable.</li>
              <li>Less than 15 days – Non-refundable.</li>
              <li>Flight/train tickets follow respective operator policies.</li>
            </ul>

            <h3>6. Itinerary Changes & Force Majeure</h3>
            <p>
              Budget Golden Triangle Tours reserves the right to modify
              itineraries due to weather conditions, traffic situations,
              political events, natural disasters, or operational reasons
              beyond our control.
            </p>

            <h3>7. Accommodation & Transportation</h3>
            <p>
              Hotels and transportation are arranged through trusted
              partners. In case of unavailability, similar category
              services will be provided without prior notice.
            </p>

            <h3>8. Responsibilities of Travelers</h3>
            <ul>
              <li>Respect local customs, monuments, and cultural heritage.</li>
              <li>Follow instructions provided by guides and drivers.</li>
              <li>Maintain discipline throughout the journey.</li>
              <li>Take responsibility for personal belongings.</li>
            </ul>

            <h3>9. Intellectual Property</h3>
            <p>
              All website content including images, itineraries, branding,
              and text belong to Budget Golden Triangle Tours and may not
              be copied or reproduced without written permission.
            </p>

            <h3>10. Cookies Policy</h3>
            <p>
              Our website uses cookies to improve browsing experience,
              analyze traffic, and enhance services. By using our website,
              you consent to our use of cookies.
            </p>

            <h3>11. Limitation of Liability</h3>
            <p>
              Budget Golden Triangle Tours acts as a travel organizer and
              shall not be liable for delays, accidents, loss of baggage,
              injury, or unforeseen circumstances during travel.
            </p>

            <h3>12. Governing Law</h3>
            <p>
              These Terms & Conditions shall be governed by and interpreted
              under the laws of India.
            </p>

            <h3>Contact Information</h3>
            <p>
              For any questions regarding Terms & Conditions, please contact:<br/>
              Email:{" "}
              <a href="mailto:info@budgetgoldentriangletours.com">
                info@budgetgoldentriangletours.com
              </a>
            </p>

          </div>
        </div>
      </div>
    </section>
  );
};

export default TermCondition;